{
  "dashboard": {
    "logoAlt": "Smart Word Labs",
    "nav": {
      "adminPortal": "بوابة الإدارة",
      "enquiries": "الاستفسارات",
      "signOut": "تسجيل الخروج"
    },
    "hero": {
      "adminBadge": "حساب مسؤول",
      "parentBadge": "حساب ولي أمر",
      "greeting": "مرحبًا{{name}}",
      "subtitle": "الدروس والفوترة والتقدم ورسائل المعلم لكل طفل في عائلتك.",
      "addChild": "إضافة طفل",
      "form": {
        "childName": "اسم الطفل",
        "age": "العمر",
        "save": "حفظ"
      }
    },
    "plan": {
      "title": "اختر خطة شهرية",
      "description": "تقييمك المجاني مُضمَّن دائمًا. تفتح الخطة الشهرية دروس المجموعات المباشرة وملاحظات الواجبات وتقارير التقدم وفق معيار CEFR.",
      "viewPlans": "عرض الخطط"
    },
    "studentMode": {
      "title": "وضع الطالب",
      "nextLesson": "الدرس القادم {{datetime}} — نقرة واحدة، دون تسجيل دخول منفصل لطفلك.",
      "noLesson": "لا يوجد درس مباشر مجدول بعد. ستظهر جلسة المجموعة القادمة هنا.",
      "joinClass": "انضمام إلى الدرس"
    },
    "scheduling": {
      "title": "الدروس والجدولة",
      "bookAnother": "حجز تقييم آخر",
      "lessonFallback": "درس",
      "reschedule": "إعادة الجدولة",
      "rescheduleToast": {
        "title": "تم طلب إعادة الجدولة",
        "description": "سيؤكد معلمك موعدًا جديدًا عبر البريد الإلكتروني."
      },
      "empty": {
        "title": "احجز تقييمك المجاني",
        "description": "مكالمة تشخيصية مدتها 20 دقيقة مع الأستاذة سلمى تحدد مستوى طفلك وفق معيار CEFR وخطته التعليمية. إنها مجانية ومُضمَّنة مع كل حساب.",
        "cta": "احجز تقييمًا مجانيًا"
      }
    },
    "billing": {
      "title": "الفوترة والاشتراك",
      "pastDue": "فشلت عملية الدفع الأخيرة. حدّث بطاقتك للحفاظ على استمرار الدروس.",
      "plan": "الخطة",
      "noPlan": "لا توجد خطة نشطة",
      "status": "الحالة",
      "statusNone": "لا يوجد",
      "accessEnds": "ينتهي الوصول في",
      "renewsOn": "يتجدد في",
      "childrenEnrolled": "عدد الأطفال المسجَّلين",
      "manageSubscription": "إدارة الاشتراك",
      "opening": "جارٍ الفتح…",
      "choosePlan": "اختر خطة"
    },
    "progress": {
      "title": "تقارير التقدم",
      "cefrLevel": "المستوى وفق CEFR",
      "awaitingAssessment": "بانتظار التقييم",
      "lessonsCompleted": "الدروس المكتملة",
      "homeworkReviewed": "الواجبات التي تمت مراجعتها",
      "submitHomework": "تسليم الواجب"
    },
    "homeworkFeedback": {
      "title": "الواجبات وملاحظات المعلم",
      "empty": "لا توجد واجبات مُسلَّمة بعد."
    },
    "messages": {
      "title": "رسائل من معلم طفلك",
      "empty": "لا توجد رسائل بعد. سينشر معلمك ملاحظات الدرس هنا بعد كل جلسة."
    },
    "toasts": {
      "childAdded": "تمت إضافة ملف الطفل",
      "paymentReceived": {
        "title": "تم استلام الدفعة",
        "description": "جارٍ إعداد خطتك — يستغرق ذلك بضع ثوانٍ."
      },
      "portalUnavailable": "البوابة غير متاحة",
      "portalError": "تعذّر فتح بوابة الفوترة"
    }
  },
  "homework": {
    "backToDashboard": "العودة إلى لوحة التحكم",
    "title": "تسليم الواجب",
    "description": "ارفع تسجيلًا صوتيًا للقراءة وأي صفحات أوراق عمل. تُخزَّن الملفات بشكل خاص ولا يراها سوى معلمك.",
    "form": {
      "lesson": "الدرس",
      "selectLesson": "اختر درسًا",
      "lessonFallback": "درس",
      "noBookings": "تحتاج إلى درس محجوز قبل تسليم الواجب.",
      "audioRecording": "تسجيل صوتي",
      "worksheet": "ورقة عمل (PDF أو صورة)",
      "uploading": "جارٍ الرفع…",
      "submit": "تسليم الواجب"
    },
    "submissions": {
      "title": "واجباتك المُسلَّمة",
      "audio": "صوت",
      "worksheet": "ورقة عمل",
      "watchVideoFeedback": "مشاهدة ملاحظات المعلم بالفيديو",
      "empty": "لم يتم تسليم أي شيء بعد."
    },
    "errors": {
      "fileTooLarge": "يجب أن يكون ملف {{kind}} أقل من 25 ميغابايت",
      "chooseLesson": "اختر الدرس الذي يخص هذا الواجب",
      "attachFile": "أرفق تسجيلًا صوتيًا أو ورقة عمل",
      "uploadFailed": "فشل الرفع",
      "openFileFailed": "تعذّر فتح الملف"
    },
    "toasts": {
      "submitted": "تم تسليم الواجب — تم إشعار معلمك"
    }
  },
  "messagesPage": {
    "backToPortal": "العودة إلى البوابة",
    "title": "استفسارات الموقع الإلكتروني",
    "description": "الرسائل المُرسَلة عبر نموذج التواصل. أنت وحدك من يمكنه رؤيتها.",
    "exportCsv": "تصدير CSV",
    "loading": "جارٍ تحميل الاستفسارات…",
    "empty": "لا توجد استفسارات بعد.",
    "childAge": "عمر الطفل {{age}}",
    "status": {
      "handled": "تمت المعالجة",
      "new": "جديد"
    },
    "actions": {
      "reopen": "إعادة الفتح",
      "markHandled": "وضع علامة كمُعالَج"
    },
    "csv": {
      "headers": {
        "received": "تاريخ الاستلام",
        "name": "الاسم",
        "email": "البريد الإلكتروني",
        "whatsapp": "واتساب",
        "childAge": "عمر الطفل",
        "subject": "الموضوع",
        "message": "الرسالة",
        "status": "الحالة"
      },
      "filename": "استفسارات-سمارت-وورد-لابز-{{date}}"
    },
    "toasts": {
      "updateFailed": "تعذّر تحديث هذا الاستفسار.",
      "nothingToExport": "لا توجد استفسارات لتصديرها بعد.",
      "exported_one": "تم تصدير استفسار واحد.",
      "exported_two": "تم تصدير استفسارين.",
      "exported_few": "تم تصدير {{count}} استفسارات.",
      "exported_many": "تم تصدير {{count}} استفسارًا.",
      "exported_other": "تم تصدير {{count}} استفسار."
    }
  },
  "admin": {
    "backToDashboard": "العودة إلى لوحة التحكم",
    "title": "بوابة الإدارة",
    "description": "المدفوعات والحجوزات والمستحقات وحسابات المستخدمين الخاصة بـ Smart Word Labs.",
    "tabs": {
      "payments": "المدفوعات",
      "bookings": "الحجوزات",
      "payouts": "المستحقات",
      "users": "المستخدمون"
    },
    "table": {
      "loading": "جارٍ التحميل…",
      "clearFilters": "مسح عوامل التصفية",
      "details": "التفاصيل",
      "view": "عرض",
      "action": "إجراء"
    },
    "payments": {
      "searchPlaceholder": "ابحث عن طالب أو معلم",
      "searchAriaLabel": "البحث في المدفوعات باسم الطالب أو المعلم",
      "filterAriaLabel": "التصفية حسب حالة الدفع",
      "filterPlaceholder": "حالة الدفع",
      "statuses": {
        "all": "جميع حالات الدفع",
        "unpaid": "غير مدفوع",
        "paid": "مدفوع",
        "refunded": "مُسترَد"
      },
      "columns": {
        "student": "الطالب",
        "tutor": "المعلم",
        "programme": "البرنامج",
        "amount": "المبلغ",
        "payment": "الدفع",
        "created": "تاريخ الإنشاء"
      },
      "empty": "لا توجد مدفوعات مطابقة لهذه الفلاتر بعد.",
      "refund": "استرداد",
      "confirm": {
        "title": "استرداد هذه الدفعة؟",
        "description": "سيصدر هذا استردادًا فعليًا عبر Stripe لـ <strong>{{name}}</strong> ({{amount}}) ويضع علامة على الحجز كمُسترَد. لا يمكن التراجع عن هذا الإجراء.",
        "fallbackName": "هذا الطالب",
        "cancel": "إلغاء",
        "confirm": "استرداد الدفعة"
      },
      "toasts": {
        "success": "تم إصدار الاسترداد وتحديد الحجز الآن كمُسترَد.",
        "error": "تعذّر إتمام عملية الاسترداد."
      }
    },
    "bookings": {
      "status": "الحالة",
      "from": "من",
      "to": "إلى",
      "statuses": {
        "all": "جميع الحالات",
        "pending": "قيد الانتظار",
        "confirmed": "مؤكد",
        "completed": "مكتمل",
        "canceled": "ملغى"
      },
      "columns": {
        "scheduled": "موعد الجدولة",
        "student": "الطالب",
        "tutor": "المعلم",
        "programme": "البرنامج",
        "status": "الحالة",
        "payment": "الدفع"
      },
      "empty": "لا توجد حجوزات مطابقة لهذه الفلاتر بعد.",
      "detail": {
        "title": "تفاصيل الحجز",
        "description": "السجل الكامل لهذا الحجز الدراسي.",
        "student": "الطالب",
        "studentEmail": "بريد الطالب الإلكتروني",
        "tutor": "المعلم",
        "programme": "البرنامج",
        "amount": "المبلغ",
        "scheduled": "موعد الجدولة",
        "created": "تاريخ الإنشاء",
        "status": "الحالة",
        "payment": "الدفع",
        "refundedAt": "تاريخ الاسترداد",
        "meetingLink": "رابط الاجتماع",
        "stripePayment": "دفعة Stripe"
      }
    },
    "payouts": {
      "totalPending": "إجمالي المستحقات المعلقة",
      "filterAriaLabel": "تصفية المستحقات حسب الحالة",
      "filterPlaceholder": "الحالة",
      "statuses": {
        "all": "جميع الحالات",
        "pending": "قيد الانتظار",
        "paid": "مدفوع"
      },
      "columns": {
        "tutor": "المعلم",
        "amount": "المبلغ",
        "payoutDate": "تاريخ الدفع",
        "status": "الحالة"
      },
      "empty": "لم يتم تسجيل أي مستحقات بعد.",
      "markAsPaid": "وضع علامة كمدفوع",
      "toasts": {
        "success": "تم وضع علامة على المستحقات كمدفوعة.",
        "error": "تعذّر تحديث هذه المستحقات."
      }
    },
    "users": {
      "filterAriaLabel": "تصفية المستخدمين حسب الدور",
      "filterPlaceholder": "الدور",
      "roles": {
        "all": "جميع الأدوار",
        "parent": "ولي أمر",
        "tutor": "معلم",
        "admin": "مسؤول"
      },
      "columns": {
        "name": "الاسم",
        "email": "البريد الإلكتروني",
        "role": "الدور",
        "joined": "تاريخ الانضمام"
      },
      "empty": "لا يوجد مستخدمون مطابقون لهذا الفلتر.",
      "viewTutor": "عرض المعلم",
      "tutorFallback": "معلم",
      "loadingTutor": "جارٍ تحميل تفاصيل المعلم…",
      "noTutorProfile": "لا يوجد ملف تعريف معلم مسجَّل.",
      "detail": {
        "hourlyRate": "الأجر بالساعة",
        "commission": "العمولة",
        "active": "نشط",
        "onboardingSubmitted": "تم تقديم إجراءات الانضمام",
        "specialisation": "التخصص",
        "bio": "نبذة تعريفية",
        "yes": "نعم",
        "no": "لا"
      }
    }
  }
}
